import { AttempsDTO } from "../../../api/Students/GetStudentAttemps";

const AttempsTable = ({ data }: { data?: AttempsDTO[] }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}.${month}.${year} - ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div>
      <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
        <table className="table-auto w-full">
          <thead className="text-lg capitalize ">
            <tr className="bg-[#F1F4F9] rounded-t-lg">
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">ID</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">IP Address</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Country</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Last Visited</div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {data?.map((attemps: AttempsDTO) => (
              <tr>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {attemps.id}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {attemps.ipAddress}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 text-center last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex  rounded-full py-0.5 text-sm font-semibold">
                    {attemps.country}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {formatDate(attemps.createdAt)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttempsTable;
